import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import ProductsSection from './ProductsSection';

const StorefrontPage = () => {
    return (
        <HelmetProvider>
            <div className="flex-1 bg-cream text-ink">
                <Helmet prioritizeSeoTags>
                    <title>Storefront — Amanda Filomena | Fitness & Lifestyle Favorites</title>
                    <link rel="canonical" href="https://amandafilomena.com/storefront" />
                    <meta name="description" content="Curated fitness gear, supplements, and lifestyle products I use and recommend. Affiliate links help support what I'm building." />
                </Helmet>

                <main className="mx-auto max-w-6xl px-6 py-20 md:py-28">
                    {/* Hero */}
                    <div className="mb-16 opacity-0 animate-fade-up">
                        <p className="text-xs font-medium tracking-[0.2em] text-terra uppercase mb-4">Shop My Favorites</p>
                        <h1 className="text-3xl md:text-4xl font-medium tracking-tight text-ink mb-4" style={{ fontFamily: "'Cinzel', serif" }}>
                            Storefront
                        </h1>
                        <p className="text-base text-muted max-w-2xl leading-relaxed">
                            Fitness gear, supplements, and lifestyle products I actually use. Some links are affiliate — they help support what I'm building.
                        </p>
                    </div>

                    {/* Shop Links */}
                    <div className="flex flex-wrap gap-3 mb-12 opacity-0 animate-fade-up-delay">
                        <a
                            href="https://www.shopltk.com/explore/Filomena.fit"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 border border-sand px-5 py-2.5 text-xs font-medium uppercase tracking-wider text-ink transition-all hover:border-terra hover:text-terra"
                        >
                            LTK
                        </a>
                        <a
                            href="https://creator.walmart.com/storefront/51496"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 border border-sand px-5 py-2.5 text-xs font-medium uppercase tracking-wider text-ink transition-all hover:border-terra hover:text-terra"
                        >
                            Walmart
                        </a>
                    </div>

                    {/* Products */}
                    <div className="opacity-0 animate-fade-up-delay-2">
                        <ProductsSection />
                    </div>

                    {/* CTA */}
                    <section className="mt-24 bg-ink p-10 md:p-14 text-center">
                        <p className="text-xs font-medium tracking-[0.2em] text-terra uppercase mb-4">Stay Connected</p>
                        <h2 className="text-2xl font-medium text-cream md:text-3xl mb-4" style={{ fontFamily: "'Cinzel', serif" }}>
                            More favorites on Instagram
                        </h2>
                        <p className="text-sm text-cream/60 mb-8 max-w-lg mx-auto">
                            I share new finds and what's working for fitness and life.
                        </p>
                        <a
                            href="https://www.instagram.com/amandafilomena_/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 bg-terra px-7 py-3.5 text-sm font-medium text-white transition-all hover:bg-terra-dark tracking-wide"
                        >
                            @amandafilomena_
                        </a>
                    </section>
                </main>

                <footer className="border-t border-sand px-6 py-8">
                    <div className="mx-auto max-w-6xl flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                        <p className="text-sm text-muted">© 2026 Amanda Filomena</p>
                        <div className="flex gap-6">
                            <a href="https://github.com/amandafc-BYU" target="_blank" rel="noopener noreferrer" className="text-xs uppercase tracking-wider text-muted hover:text-terra transition-colors">
                                GitHub
                            </a>
                            <a href="mailto:hello@amandafilomena.com" className="text-xs uppercase tracking-wider text-muted hover:text-terra transition-colors">
                                Contact
                            </a>
                        </div>
                    </div>
                </footer>
            </div>
        </HelmetProvider>
    );
};

export default StorefrontPage;
